// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'sigma';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M15.563.561H2.857a.562.562 0 0 0-.398.96l6.682 6.682a1.125 1.125 0 0 1 0 1.59L2.46 16.476a.563.563 0 0 0 .398.961h12.704'
  />
);

export const viewBox = '0 0 18 18';
